export const GET_BANNER_REQUEST = 'GET_BANNER_REQUEST';
export const GET_BANNER_RESPONSE = 'GET_BANNER_RESPONSE';
export const GET_BANNER_ERROR = 'GET_BANNER_ERROR';
export const DISMISS_BANNER = 'DISMISS_BANNER';

export const loadBanners = () => ({type: GET_BANNER_REQUEST});
export function dismissBanner(banners) {
    return { type: DISMISS_BANNER, banners };
  }